import React, { useRef } from 'react';

import cn from 'classnames';
import { node, string, func } from 'prop-types';

import { Popover } from '@mui/material';

import { useArrowKeysNavigation } from 'components/Common/ArrowKeysNavigation';

import s from './SideNavMenu.css';

export default function SideNavMenu(props) {
  const { children, className, anchorEl, hideMenu } = props;
  const ref = useRef(null);

  useArrowKeysNavigation({
    autoFocusOnOpen: true,
    containerRef: ref,
    onClose: () => {
      hideMenu();
      // prevent default browser behavior
      return true;
    },
  });

  return (
    <Popover
      ref={ref}
      open
      classes={{ paper: cn(s.menu, className) }}
      onClick={hideMenu}
      onClose={hideMenu}
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      disablePortal
    >
      {children}
    </Popover>
  );
}

SideNavMenu.propTypes = {
  children: node,
  className: string,
  anchorEl: node,
  hideMenu: func,
};

SideNavMenu.defaultProps = {
  children: undefined,
  className: undefined,
  anchorEl: undefined,
  hideMenu: () => null,
};
